module.exports = __webpack_public_path__ + "img/group-meta.dd82bc31.svg";